import { Injectable } from '@angular/core';

import { AppService } from './app.service';
import { ConfigService } from './app-config.service';
import { ApiType, HeaderType, ResponseStatusType, UserFunctionsType } from '../enumerators/enumerators.enum';
import { MessageService } from './message.service';
import { AlertType, DialogType, OptionType } from '../enumerators/messages.enum';
import { SystemService } from './system.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { DialogOption } from '../models/dialog-option.model';
import { MenuOption } from '../models/menu-option.model';
import { Response } from '../models/response.model';
import { reject } from 'lodash';
import { User } from '../models/user.model';

@Injectable()
export class UserService {
    urlUsuario: string = '';
    urlUsuarioAdmin: string = '';
    urlIdioma: string;
    urlLanguages: string = '';
    urlParams: string = '';
    logeando: boolean = false;

    timerSesion: any;
    sesionFin: any;

    constructor(private appService: AppService, private configService: ConfigService, private messageService: MessageService, private systemService: SystemService, public translate: TranslateService, private router: Router) {
        if (localStorage.getItem(this.systemService.localStoreVariable.JWT) && !localStorage.getItem(this.systemService.localStoreVariable.AOT)) {
            localStorage.removeItem(this.systemService.localStoreVariable.JWT);
        }


        this.urlIdioma = this.configService.config.servicesUrl + 'configuracion';
        this.urlLanguages = this.configService.config.servicesUrl + 'languages';
        this.urlParams = this.configService.config.servicesUrl + 'params';
        this.setAPI();

        this.appService.logOut.subscribe((url) => {
            if (url && !url.includes('/usuario/cerrarsesion')) {
                this.logOut();
            }
        });
    }

    // sesion
    logIn(datos: any) {
        this.logeando = true;
        this.appService.post(this.urlUsuario, datos, [HeaderType.Encryption]).subscribe({
            next: (response: any) => {
                if (response.status == ResponseStatusType.OK) {

                    response = this.appService.decrypt(response.data);
                    localStorage.setItem(this.systemService.localStoreVariable.JWT, response.token);
                    localStorage.setItem(this.systemService.localStoreVariable.AOT, this.appService.decrypt(response.aot, false));
                    var tema: string | null = localStorage.getItem('tema');
                    if (!tema) { localStorage.setItem('tema', 'md-light-indigo.css'); }
                    localStorage.removeItem(this.systemService.localStoreVariable.LenguajeCambiado);

                    this.setAPI();

                    this.router.navigateByUrl('/app/home');
                }
                else {
                    this.messageService.alert(AlertType.Warning, this.translate.instant(response.message));
                }
                this.logeando = false;
            },
            error: (error: any) => {
                this.logeando = false;
                this.messageService.alert(AlertType.Warning, this.translate.instant('ErrorConexion'));
                // console.log('NO PASO', error);
            }
        });
    }

    logOut() {
        this.appService.put(this.urlUsuario + '/log-out', null).subscribe(
            (response) => {
                if (response.status == ResponseStatusType.OK) {
                }
                else {
                }
                this.logOutConfirmed();
            },
            (error) => {
                this.logOutConfirmed();
            });
    }

    logOutConfirmed() {
        if (this.timerSesion) {
            clearInterval(this.timerSesion);
            this.timerSesion = null;
        }

        this.systemService.clearSessionData();
        this.setAPI();
        this.router.navigateByUrl('/');
    }

    logOutMask() {
        this.appService.put(this.urlUsuario + '/logout-mask', null).subscribe(
            (response) => {
                if (response.status == ResponseStatusType.OK) {
                    window.location.reload();
                }
                else {
                    this.messageService.alert(AlertType.Warning, this.translate.instant(response.message));
                }
            },
            (error) => {
                this.messageService.alert(AlertType.Warning, this.translate.instant('ErrorConexion'));
            });
    }

    resetUserPassword(usuario: User) {
        return new Promise((resolve) => {
            usuario.department = undefined;
            this.appService.put(this.urlUsuarioAdmin + '/reset-password', usuario).subscribe(
                {
                    next: (response: any) => {
                        if (response.status == ResponseStatusType.OK) {
                            this.messageService.alert(AlertType.Success, this.translate.instant('OperacionExitosa'));
                            return resolve(true);
                        }
                        else {
                            this.messageService.alert(AlertType.Warning, this.translate.instant(response.message));
                            return resolve(false);
                        }
                    },
                    error: (error: any) => {
                        this.messageService.alert(AlertType.Warning, this.translate.instant('ErrorConexion'));
                        return resolve(false);
                    }
                });
        });
    }

    // datos
    loadInitialData() {
        return new Promise((resolve, reject) => {
            if (!this.systemService.loadedInitialData) {
                if (this.systemService.languages.length == 0) {
                    this.appService.get(this.urlLanguages).subscribe(
                        {
                            next: (response: Response) => {
                                if (response.status === ResponseStatusType.OK) {
                                    const data = this.appService.decrypt(response.data!);
                                    this.systemService.languages = data;
                                    this.systemService.setLanguages();

                                    if (this.systemService.parameters.length == 0) {
                                        this.loadParameters().then((response: any) => {
                                            return resolve(1);
                                        });
                                    } else {
                                        return resolve(1);
                                    }
                                }
                                else {
                                    this.messageService.alert(AlertType.Warning, this.translate.instant(response.message!));
                                    reject(new Error('Error al cargar los idiomas'));
                                }

                            },
                            error: () => {
                                this.messageService.alert(AlertType.Warning, this.translate.instant('ErrorConexion'));
                                this.systemService.menuOptions = [];
                                reject(new Error('Error al cargar los idiomas'));
                            }
                        }
                    );
                } else {
                    if (this.systemService.parameters.length == 0) {
                        this.loadParameters().then((response: any) => {
                            return resolve(1);
                        });
                    } else {
                        return resolve(1);
                    }

                }
            }
            else {
                return resolve(1);
            }
        });
    }

    loadParameters() {
        return new Promise((resolve) => {
            this.appService.get(this.urlParams).subscribe(
                {
                    next: (response: Response) => {
                        if (response.status === ResponseStatusType.OK) {
                            const data = this.appService.decrypt(response.data!);
                            const params = data;
                            this.systemService.parameters = params;
                            resolve(1);
                        }
                        else {
                            this.messageService.alert(AlertType.Warning, this.translate.instant(response.message!));
                            reject(new Error('Error al cargar los parametros'));
                        }
                    },
                    error: () => {
                        this.messageService.alert(AlertType.Warning, this.translate.instant('ErrorConexion'));
                        this.systemService.menuOptions = [];
                        reject(new Error('Error al cargar los parametros'));
                    }
                }
            );
        });
    }

    loadPermissions() {
        return new Promise((resolve) => {
            this.appService.get(this.urlUsuario + '/permissions').subscribe(
                {
                    next: (response: Response) => {
                        if (response.status === ResponseStatusType.OK) {
                            let data = this.appService.decrypt(response.data!);
                            this.systemService.permissions = data.permissions;

                            this.systemService.setUser(data.user);
                            this.systemService.user.maskedUser = data.maskUser;
                            this.systemService.user.currentUser = data.currentUser;
                            this.systemService.menuOptions = data.menuOptions;

                            this.systemService.getHomeMenu();

                            this.systemService.loadedPermissions = true;

                            if (this.systemService.user.maskedUser) {
                                if (localStorage.getItem(this.systemService.localStoreVariable.UsuarioEnmascarado) === '1') {
                                    localStorage.removeItem(this.systemService.localStoreVariable.UsuarioEnmascarado);
                                }
                                else {
                                    let opciones = [];

                                    opciones.push(new DialogOption({ title: this.systemService.user.currentUser?.person?.name, value: 1, type: OptionType.Negative }));
                                    opciones.push(new DialogOption({ title: this.systemService.user.maskedUser?.person?.name, value: 2, type: OptionType.Negative }));
                                    const mensaje = this.translate.instant('Perfil.MensajeUsuarioEnmascarado');

                                    this.messageService.dialog(DialogType.Advise, '', mensaje, opciones).then((response: any) => {
                                        if (!response) {
                                            this.logOutMask();
                                        }
                                    });
                                }
                            }

                            if (!this.systemService.user.userType?.permanentSession) {
                                this.systemService.user.userType!.inactivityTime = (this.systemService.user.userType?.inactivityTime! - 1) * 60 * 1000;
                                this.systemService.user.userType!.sessionTime = (this.systemService.user.userType?.sessionTime! - 0.5) * 60;

                                this.appService.startIdleCount.next(1);
                                this.setSessionTimer();
                            }

                            if (this.systemService.user.resetPassword) {
                                this.router.navigateByUrl('/app/change-password');
                            }

                            return resolve(1);
                        } else {
                            this.messageService.alert(AlertType.Warning, this.translate.instant(response.message!));
                            this.systemService.menuOptions = [];
                            return resolve(0);
                        }
                    },
                    error: () => {
                        this.messageService.alert(AlertType.Warning, this.translate.instant('ErrorConexion'));
                        this.systemService.menuOptions = [];
                        return resolve(0);
                    }
                }
            );
        });
    }

    getMenuOptions(menuOptions: any) {
        let newMenuOptions: MenuOption[] = [];

        menuOptions?.forEach((menu: { TipoModulo: any; Ruta: any; Titulo: any; Icono: any; PantallaInicio: any; Abierto: any; Activo: any; TipoIconoId: any; Orden: any; OrdenInicio: any; SubMenu: { TipoModulo: any; Ruta: any; Titulo: any; Icono: any; PantallaInicio: any; Abierto: any; Activo: any; TipoIconoId: any; Orden: any; OrdenInicio: any; }[] | undefined; }) => {
            let menuOption: MenuOption = {
                moduleType: menu.TipoModulo,
                path: menu.Ruta,
                title: menu.Titulo,
                icon: menu.Icono,
                screenIdentifier: menu.Ruta,
                homeScreen: menu.PantallaInicio,
                isOpen: menu.Abierto,
                isActive: menu.Activo,
                subMenu: [],
                order: menu.Orden,
                homeOrder: menu.OrdenInicio,
                function: UserFunctionsType.ChangePassword
            }

            if (menu.SubMenu !== undefined) {
                menuOption.subMenu = this.getMenuOptions(menu.SubMenu);
            }

            newMenuOptions.push(menuOption);
        });

        return newMenuOptions;
    }

    // Idioma
    changeLanguage(clave: any) {
        if (this.systemService.selectedLanguage?.keyCode != clave) {
            if (localStorage.getItem(this.systemService.localStoreVariable.JWT)) {
                this.changeUserLanguage(clave);
            }
            else {
                localStorage.setItem(this.systemService.localStoreVariable.LenguajeCambiado, '1');
                this.systemService.changeLanguage(clave);
            }
        }
    }

    changeUserLanguage(idiomaClave: any) {
        this.appService.post(this.urlUsuario + '/idioma', { Clave: idiomaClave }).subscribe(
            (response: any) => {
                if (response.status == ResponseStatusType.OK) {
                    this.systemService.changeLanguage(idiomaClave);
                }
                else {
                }
            },
            (error: any) => {
            });
    }

    // Funciones de sesion
    resumeSession() {
        this.appService.put(this.urlUsuario + '/reanudarSesion', null).subscribe(
            (response: any) => {
                if (response.status == ResponseStatusType.OK) {
                    localStorage.removeItem(this.systemService.localStoreVariable.SesionValida);
                    this.setSessionTimer();
                }
                else {
                    this.appService.sessionEnded.next(true);
                    this.messageService.alert(AlertType.Warning, this.translate.instant(response.message));
                }
            },
            (error: any) => {
                this.appService.sessionEnded.next(true);
                this.messageService.alert(AlertType.Warning, this.translate.instant('ErrorConexion'));
            });
    }

    setSessionTimer() {
        if (localStorage.getItem(this.systemService.localStoreVariable.SesionValida)) {
            var fecha = localStorage.getItem(this.systemService.localStoreVariable.SesionValida);
            this.sesionFin = new Date(fecha ?? '');
        }
        else {
            this.sesionFin = new Date();
            this.sesionFin.setSeconds(this.sesionFin.getSeconds() + (this.systemService.user.userType?.sessionTime));
            localStorage.setItem(this.systemService.localStoreVariable.SesionValida, this.sesionFin);
        }

        this.startSessionTimer();
    }

    startSessionTimer() {
        this.timerSesion = setInterval(() => {
            var tiempo = this.timeDifference(this.sesionFin);

            if (tiempo == 0) {
                clearInterval(this.timerSesion);
                this.timerSesion = null;
                this.appService.sessionEnded.next(true);
            }

        }, 1000);
    }

    timeDifference(termina: any) {
        var dateEntered = termina;
        var now = new Date();
        var difference = dateEntered.getTime() - now.getTime();

        if (difference <= 0) {
            clearInterval(this.timerSesion);
            this.timerSesion = null;

            return 0;
        }
        else {
            var segundos = Math.ceil(difference / 1000);

            return segundos;
        }
    }

    setAPI() {

        var api = localStorage.getItem(this.systemService.localStoreVariable.AOT) ? ApiType.Rest : ApiType.Security;
        this.configService.setURLBase(api);

        this.configService.config.servicesUrl = this.appService.base64ToString(this.configService.config.servicesUrl);


        this.setUserUrl(api);
    }

    setUserUrl(api: ApiType) {

        if (api == ApiType.Rest) {
            this.urlUsuario = this.configService.config.servicesUrl + 'users';
            this.urlUsuarioAdmin = this.configService.config.servicesUrl + 'users';
        } else {
            this.urlUsuario = this.configService.config.servicesUrl + 'authentication';
            this.urlUsuarioAdmin = this.configService.config.servicesUrl + 'users';
        }

    }
}
